import axios from "axios";

const baseUrl = process.env.REACT_APP_MAIN_API_Url;

const EmailService = {
  sendEmail: async (emailRequest) => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/Email/send-email`,
        emailRequest
      );
      return response.data;
    } catch (error) {
      console.error(
        "Error sending email:",
        error.response?.data || error.message
      );
      throw error;
    }
  },

  sendEmailReminder: async (emailReminderRequest) => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/Email/send-reminder`,
        emailReminderRequest
      );
      return response.data;
    } catch (error) {
      console.error(
        "Error sending email reminder:",
        error.response?.data || error.message
      );
      throw error;
    }
  },

  sendTaskAssignmentEmail: async (taskAssignmentRequest) => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/Email/send-task-assignment`,
        taskAssignmentRequest
      );
      return response.data;
    } catch (error) {
      console.error(
        "Error sending task assignment email:",
        error.response?.data || error.message
      );
      throw error;
    }
  },

  sendUserRemovalEmail: async (userRemovalRequest) => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/Email/send-user-removal`,
        userRemovalRequest
      );
      return response.data;
    } catch (error) {
      console.error(
        "Error sending user removal email:",
        error.response?.data || error.message
      );
      throw error;
    }
  },
};

export default EmailService;
